// 2 approches possibles pour le routage :
// - PATH_PREFIX (retenue pour l'instant)
// - BASE_NAME
// Voir le /readme.md,
// Voir src/App.tsx

// APPROCHE PATH_PREFIX
const PREFIX = process.env.REACT_APP_B2C_PREFIX || '';
// APPROCHE BASE_NAME
//const PREFIX = '';
const PREFIX_THERMIQUE = process.env.REACT_APP_B2C_THERMIQUE_PREFIX || '';

export const buildPath = (path: string, params: Record<string, string | number>) => {
    return Object.entries(params).reduce((acc, [key, value]) => acc.replace(`:${key}`, String(value)), path);
};

export const buildPathThermique = (path: string, params: Record<string, string | number>) => {
    return `${buildPath(path, params).replace(PREFIX, PREFIX_THERMIQUE)}`;
};
export const buildFullPathThermique = (path: string, params: Record<string, string | number>) => {
    return `${window.location.origin}${buildPathThermique(path, params)}`;
};

// Normalement cette route n'existe plus.
// On repart sur home, le projet chapeau.
// Mais on garde quand même pour l'instant, pour gérer en local, parce que je suis aps encore sur que ca marche.
// et puis vu le montage, un petit plan B, ca mange aps de pain.
export const ROUTE_LOGIN = `${PREFIX}/login`;

export const ROUTE_ROOT = `${PREFIX}/`;
export const ROUTE_MENTIONS_LEGALES = `${PREFIX}/mentions-legales`;

// AUDIT
export const ROUTE_AUDIT = `${PREFIX}/audit`;
export const ROUTE_AUDIT_ID = `${PREFIX}/audit/:id`;
export const ROUTE_AUDIT_INFO_CLIENT = `${PREFIX}/audit/informations-client`;
export const ROUTE_AUDIT_INFO_HABITATION = `${PREFIX}/audit/informations-habitation`;
export const ROUTE_AUDIT_INFO_SYSTEMES_ENERGETIQUES = `${PREFIX}/audit/informations-systemes-energetiques`;
export const ROUTE_AUDIT_INFO_DEPENSES_ENERGETIQUE = `${PREFIX}/audit/informations-depenses-energetiques`;
export const ROUTE_AUDIT_INFO_RECUEIL_CONSTAT = `${PREFIX}/audit/informations-recueil-constat`;
export const ROUTE_AUDIT_INFO_EVELOPPE = `${PREFIX}/audit/informations-enveloppe`;

export const ROUTE_AUDIT_OUVRANT = `${PREFIX}/audit/ouvrants`;
export const ROUTE_AUDIT_PHOTOS = `${PREFIX}/audit/photos`;
export const ROUTE_AUDIT_RDV = `${PREFIX}/audit/rendez-vous`;

export const ROUTE_AUDIT_FINALISATION_SANS_RDV = `${PREFIX}/audit/finalisation-sans-rendez-vous`;
export const ROUTE_AUDIT_RDV_SIGNATURE = `${PREFIX}/audit/rendez-vous-signature`;

// AUDIT THERMIQUE
// export const ROUTE_AUDIT_THERMIQUE = `${PREFIX}/audit-thermique/audit`;

// ACTION LOGEMENT
export const ROUTE_AUDIT_AL = `${PREFIX}/audit/action-logement`;
export const ROUTE_AUDIT_AL_RECAP = `${PREFIX}/audit/action-logement/recapitulatif`;
export const ROUTE_AUDIT_AL_RECAP_INELIGIBLE_PV = `${PREFIX}/audit/action-logement/recapitulatif-ineligible-photovoltaique`;
export const ROUTE_AUDIT_AL_RECAP_INELIGIBLE = `${PREFIX}/audit/action-logement/recapitulatif-ineligible`;
export const ROUTE_AUDIT_AL_SIGNATURE = `${PREFIX}/audit/action-logement/signature`;
export const ROUTE_AUDIT_AL_FINALISATION = `${PREFIX}/audit/action-logement/finalisation`;

// RESTE A CHARGE
export const ROUTE_AUDIT_RAC = `${PREFIX}/audit/reste-a-charge`;
export const ROUTE_AUDIT_RAC_RECAP = `${PREFIX}/audit/reste-a-charge/recapitulatif`;
export const ROUTE_AUDIT_RAC_FINALISATION = `${PREFIX}/audit/reste-a-charge/finalisation`;

// RECOMMANDATION
export const ROUTE_SIM_RECOMMANDATION = `${PREFIX}/simulator/recommandation`;

// BON DE COMMANDE
export const ROUTE_SIM_SYNTHESE = `${PREFIX}/bon-de-commande/synthese`;
export const ROUTE_SIM_PAC = `${PREFIX}/bon-de-commande/pompe-a-chaleur`;
export const ROUTE_SIM_BON_DE_COMMANDE = `${PREFIX}/bon-de-commande/recapitulatif`;
export const ROUTE_SIM_DEVIS = `${PREFIX}/bon-de-commande/devis`;
export const ROUTE_SIM_EXIT = `${PREFIX}/bon-de-commande/exit`;
export const ROUTE_SIM_ANNEXE = `${PREFIX}/bon-de-commande/annexe`;
export const ROUTE_SIM_ENGAGEMENT_CLIENT = `${PREFIX}/bon-de-commande/engagement-client`;
export const ROUTE_SIM_FINANCEMENT = `${PREFIX}/bon-de-commande/financement`;
export const ROUTE_SIM_TVA = `${PREFIX}/bon-de-commande/tva`;
export const ROUTE_SIM_RENDEMENT = `${PREFIX}/bon-de-commande/rendement`;
export const ROUTE_SIM_SIGN = `${PREFIX}/bon-de-commande/Sign`;
export const ROUTE_SIM_PDF = `${PREFIX}/bon-de-commande/pdf`;

// PRE VISITE
export const ROUTE_PV_VALIDATION = `${PREFIX}/pre-visite/validation`;
export const ROUTE_PV_POMPE_A_CHALEUR = `${PREFIX}/pre-visite/pompe-a-chaleur`;
export const ROUTE_PV_PHOTOVOLTAIQUE = `${PREFIX}/pre-visite/photovoltaique`;
export const ROUTE_PV_THERMODYNAMIQUE = `${PREFIX}/pre-visite/thermodynamique`;
export const ROUTE_PV_PREVISION = `${PREFIX}/pre-visite/prevision`;
export const ROUTE_PV_PLANNING = `${PREFIX}/pre-visite/planning`;
export const ROUTE_PV_FIN_DE_COMMANDE = `${PREFIX}/pre-visite/fin-de-commande`;
export const ROUTE_PV_FINALISATION = `${PREFIX}/pre-visite/finalisation`;
export const ROUTE_PV_PDF = `${PREFIX}/pre-visite/pdf`;

// ESPACE AGENT
export const ROUTE_EA_INDEX = `${PREFIX}/espace-agent`;
export const ROUTE_EA_LIST = `${PREFIX}/espace-agent/list-audit`;
export const ROUTE_EA_CREATION = `${PREFIX}/espace-agent/creation-audit`;
export const ROUTE_EA_FORMATION = `${PREFIX}/espace-agent/espace-formation`;
export const ROUTE_EA_COMPTE = `${PREFIX}/espace-agent/mon-compte`;
export const ROUTE_EA_DETAIL = `${PREFIX}/espace-agent/list-audit/:id`;
export const ROUTE_EA_NETWORK = `${PREFIX}/espace-agent/mon-reseau`;
export const ROUTE_EA_NETWORK_DETAIL = `${PREFIX}/espace-agent/mon-reseau/:id`;
export const ROUTE_EA_CREATE = `${PREFIX}/espace-agent/creation-agent`;
export const ROUTE_EA_MARKETING = `${PREFIX}/espace-agent/outil-marketing`;
